<template>
  <div>
    <h1 id="edit-title">Edit {{ activeField.title }}</h1>
    <tabs :options="{ useUrlFragment: false }">
      <tab name="Basic Info">
        <vue-form-generator
          :schema="buildSchema('field', 'fieldSchema', 'basicInfo', 'edit')"
          :model="formModel"
          :options="formOptions" />
      </tab>
      <tab name="Validation">
        <vue-form-generator
          :schema="buildSchema('field', 'fieldSchema', 'validation', 'edit')"
          :model="formModel"
          :options="formOptions" />
      </tab>
      <tab name="Field Options" v-if="fieldHasOptions">
        <vue-form-generator
          :schema="buildSchema('field', 'fieldSchema', 'fieldOptions', 'edit')"
          :model="objects[activeObject]"
          :options="formOptions" />

        <div class="list-view list-view--inline" v-if="objects.length > 1">
          <div class="list-view__header">
            <div>Text</div>
            <div>Value</div>
            <div class="list-view__small-column">Position</div>
            <div class="list-view__small-column">Actions</div>
          </div>

          <template v-for="(fieldOption, index) in initialObjects" :key="fieldOption.id">
            <div class="list-view__row" v-if="index > 0">
              <div>{{ fieldOption.text }}</div>
              <div>{{ fieldOption.value }}</div>
              <div class="list-view__small-column">
                <span class="show-for-small">Position:&nbsp;</span>{{ fieldOption.position }}
              </div>
              <div class="list-view__small-column list-actions list-actions--stacked">
                <div class="list-actions__group">
                  <button
                    class="icon-button list-action"
                    @click="alterPosition(fieldOption.id, fieldOption.position - 1)"
                    :disabled="index === 1">
                      <i class="fa-solid fa-arrow-up" />
                      <span class="list-action__label">Move Up</span>
                  </button>
                  <button
                    class="icon-button list-action"
                    @click="alterPosition(fieldOption.id, fieldOption.position + 1)"
                    :disabled="index === objects.length - 1">
                      <i class="fa-solid fa-arrow-down" />
                      <span class="list-action__label">Move Down</span>
                  </button>
                </div>
                <div class="list-actions__group">
                  <button class="icon-button list-action" @click="editObject(index)">
                    <i class="fa-solid fa-pen-to-square" />
                    <span class="list-action__label">Edit</span>
                  </button>
                  <button class="icon-button list-action" @click="deleteObject(fieldOption)">
                    <i class="fa-solid fa-trash" />
                    <span class="list-action__label">Delete</span>
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </tab>
    </tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import editForm from '@/mixins/edit-form';
import inlineEditForm from '@/mixins/inline-edit-form';

export default {
  name: 'admin-edit-field',
  mixins: [editForm, inlineEditForm],

  data: () => {
    return {
      formIndex: 'admin-fields',
      formName: 'Field',
      inlineName: 'FieldOption',
      inlineId: 'options',
    };
  },

  computed: {
    ...mapGetters('admin', [
      'activeField',
    ]),

    fieldHasOptions() {
      return ['dropdown', 'checkbox', 'radio'].includes(this.activeField.savedFieldType);
    },
  },

  watch: {
    activeField: {
      handler() {
        this.defineFormObjects();
        this.setupObjects();
      },
      deep: true,
    },
  },

  methods: {
    alterPosition(fieldOptionId, position) {
      this.$store.dispatch('admin/editFieldOption', { data: { id: fieldOptionId, position }, noCommit: true })
        .then(() => this.$store.dispatch('admin/fetchFieldOptions', { dependsOn: this.activeField.id }));
    },
  },
};
</script>
